import { useState, useEffect } from "react";
import { Box, Button, CloseButton, Dialog, HStack, Portal, Text, VStack } from "@chakra-ui/react";
import LeadStatusBadge from "../LeadStatusBadge";
import { Field, FormTextarea } from "@/components/jobOffer/ui";

const LEAD_STATUSES = [
    "New", "ContactAttempted", "Contacted", "Conversation", "Qualifying", "Qualified",
    "Interested", "ConversionProposed", "Converted", "NotInterested", "NoResponse",
    "Disqualified", "HandedToHuman",
];

const ChangeLeadStatusModal = ({ isOpen, onClose, currentStatus, onSubmit, isLoading }) => {
    const [selectedStatus, setSelectedStatus] = useState(currentStatus);
    const [note, setNote] = useState("");

    useEffect(() => {
        if (isOpen) {
            setSelectedStatus(currentStatus);
            setNote("");
        }
    }, [isOpen, currentStatus]);

    return (
        <Dialog.Root open={isOpen} onOpenChange={(e) => { if (!e.open) onClose(); }}>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner p={4}>
                    <Dialog.Content
                        bg="white" color="gray.900" borderColor="gray.200" border="1px solid"
                        boxShadow="0 4px 24px rgba(23,21,31,0.12)"
                        w={{ base: "calc(100vw - 2rem)", md: "lg" }} maxW="100%" maxH="calc(100dvh - 2rem)"
                        overflowY="auto" borderRadius={12}
                    >
                        <Dialog.Body pt={6} pb={6} px={6}>
                            <Text fontWeight={700} fontSize="lg" color="gray.900" mb={4}>Zmień status leada</Text>
                            <VStack align="stretch" gap={2} mb={4}>
                                {LEAD_STATUSES.map(s => (
                                    <Box
                                        key={s} as="button" onClick={() => setSelectedStatus(s)}
                                        display="flex" alignItems="center" gap={3} px={3} py={2} borderRadius={8}
                                        border="1px solid" borderColor={selectedStatus === s ? "purple.400" : "gray.200"}
                                        bg={selectedStatus === s ? "purple.50" : "white"}
                                        cursor="pointer" transition="all 0.15s" _hover={{ borderColor: "purple.400" }}
                                        outline="none" textAlign="left"
                                    >
                                        <LeadStatusBadge status={s} />
                                    </Box>
                                ))}
                            </VStack>
                            <Field label="Notatka (opcjonalnie)">
                                <FormTextarea
                                    placeholder="Powód zmiany statusu..."
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    rows={3}
                                    resize="vertical"
                                />
                            </Field>
                            <HStack justify="flex-end" gap={2} mt={4}>
                                <Button variant="ghost" size="sm" onClick={onClose} disabled={isLoading}>Anuluj</Button>
                                <Button
                                    variant="primary" size="sm" loading={isLoading} disabled={!selectedStatus}
                                    onClick={() => onSubmit(selectedStatus, note.trim() || null)}
                                >
                                    Zapisz
                                </Button>
                            </HStack>
                        </Dialog.Body>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" position="absolute" top="2" right="2" color="gray.400" _hover={{ color: "gray.600", bg: "gray.100" }} />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default ChangeLeadStatusModal;
